var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector5Red(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0007 49.1663C11.6534 49.1663 0.833984 38.3469 0.833984 24.9997C0.833984 11.6524 11.6534 0.833008 25.0007 0.833008C38.3479 0.833008 49.1673 11.6524 49.1673 24.9997C49.1673 38.3469 38.3479 49.1663 25.0007 49.1663ZM37.084 34.6663L49.1673 24.9997L37.084 15.333V22.583H17.7507V27.4163H37.084V34.6663Z",
    fill: "#F05A28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5Red);
export default __webpack_public_path__ + "static/media/vector-5-red.f57c3df01b06624cee13c91e37f3f6db.svg";
export { ForwardRef as ReactComponent };